// Production-safe logger - only logs in development mode
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => isDev && console.log(...args),
  warn: (...args) => isDev && console.warn(...args),
  error: (...args) => console.error(...args), // Always log errors
  debug: (...args) => isDev && console.log('[DEBUG]', ...args),
};

export default logger;
